import { Component, ElementRef, forwardRef, Input, OnInit, OnChanges, SimpleChanges, QueryList, ViewChild, ViewChildren, AfterViewInit   } from '@angular/core';
import { NG_VALUE_ACCESSOR, } from '@angular/forms';
import SignaturePad from 'signature_pad';
import { MainService } from 'src/app/services/main/main.service';

@Component({
  selector: 'app-signature-new',
  templateUrl: './signature-new.component.html',
  styleUrls: ['./signature-new.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SignatureNewComponent),
      multi: true,
    },
  ]
})

export class SignatureNewComponent implements OnInit, OnChanges, AfterViewInit   {
  @ViewChild('textInput', { static: false }) textInput!: ElementRef<HTMLInputElement>;
  @ViewChild('textCanvas', { static: false }) textCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('image', { static: false }) image!: ElementRef<HTMLImageElement>;
  // @ViewChild(SignaturePad, { static: false }) public signaturePad: SignaturePad;
  @ViewChild('signaturePad', { static: false }) signaturePadElementRef: ElementRef<HTMLCanvasElement>;

  @ViewChildren(SignatureNewComponent) public sigs: QueryList<SignatureNewComponent>;
  @ViewChildren('sigContainer1') public sigContainer1: QueryList<ElementRef>;
  @Input() canvasWidth: number = 750;
  @Input() canvasHeight: number = 280; // Default height
  @Input() signType: any;
  @Input() name: any;
  selectedTabs = 0;
  showError = false;
  count = 0;
  count2 = 0;
  showImg = false;
  showSigns: boolean = false;
  intervalId: any;
  intervalId2: any;
  counter = 0;
  singnatureContext: any;
  fromApplyFont: any = 0;
  signContent: string = '';

  public signaturePadOptions: Object = {
    'minWidth': 2,
    'canvasWidth': 760,
    'canvasHeight': 280,
    'penColor': '#000000'
  };
  public _signature: any = null;
  public propagateChange: Function | any = null;
  counterboolean: boolean = true;
  signaturePad: SignaturePad;
  signatureSaved: any;

  constructor(public mainService: MainService,) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['name'] && !changes['name'].firstChange && this.textInput) {
      this.textInput.nativeElement.value = changes['name'].currentValue || '';
      this.signContent = '';
      this.resetSign();
      this.showSigns = true;
      this.showSignImg();
    }
  }

  ngOnInit() {
    if (this.canvasWidth) {
      this.signaturePadOptions = {
        'minWidth': 2,
        'canvasWidth': this.canvasWidth,
        'canvasHeight': this.canvasHeight || 280,
        'penColor': '#000000'
      };
    }
    if (!this.canvasWidth && this.canvasHeight) {
      this.signaturePadOptions = {
        'minWidth': 2,
        'canvasWidth': 760,
        'canvasHeight': this.canvasHeight || 280,
        'penColor': '#000000'
      };
    }
    for (let i = 1; i <= 13; i++) {
      const preloadFont = `italic 30px BrotherSignature${i}`;
      (document as any).fonts.load(preloadFont);
    }
    (document as any).fonts.load('italic 500 30px Lato');
    (document as any).fonts.load('italic 30px Poppins');

  }

  setFont() {
    // this.initFontFamily();
    if (this.count === 15) {
      this.count = 0;
      return;
    }
    this.singnatureContext = this.textCanvas.nativeElement.getContext('2d');
    if (this.singnatureContext) {
      this.intervalId2 = setInterval(() => {
        let width = (this.singnatureContext && this.singnatureContext.canvas && this.singnatureContext.canvas['width']) || null
        let height = (this.singnatureContext && this.singnatureContext.canvas && this.singnatureContext.canvas['height']) || null
        if(!height || !width) return
        this.singnatureContext.clearRect(0, 0, width, height);
        this.singnatureContext.font = `italic 40px BrotherSignature${this.count == 1 ? 0 : this.count}`;
        if (this.count == 15) {
          clearInterval(this.intervalId2);
          return;
        }
        this.updateImage();
        this.count++;
        // this.setFont();
      }, 800);
    }
  }

  onToggleChange(event: Event): void {
    let isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedTab(1); 
      setTimeout(() => {
        this.count = 0;
        this.setFont();
      }, 800);
    } else {
      this.selectedTab(0);
    }
  }

  selectedTab(type: any) {
    if(this.selectedTabs == type) {
      return;
    }
    this.selectedTabs = type;
    if (this.selectedTabs) {
      clearInterval(this.intervalId2);
    }
    if (this.selectedTabs == 0 ) {
      this.showSigns = true;
      setTimeout(() => {
        this.textInput.nativeElement.value = this.textInput.nativeElement.value || this.name;
        this.showSignImg();
      }, 0);
      return;
    }
    this.resetSign();
    if(type){
      setTimeout(() => {
        this.signaturePad = new SignaturePad(this.signaturePadElementRef.nativeElement);
        const canvas = this.signaturePadElementRef.nativeElement;
        const ctx = canvas.getContext('2d');
    
        // Set canvas background to white
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    
        this.signaturePad.addEventListener('mouseup', () => {
          this.save()
        })

        this.signaturePad.addEventListener("endStroke", () => {
          if (!this.signaturePad.isEmpty()) {
            this.save();
          }
        });
    
        canvas.addEventListener('mouseleave', () => {
          if (!this.signaturePad.isEmpty()) {
            this.save()
          }
        })
      }, 0);
    }
  }

  editSign() {
      this.textInput.nativeElement.focus();
  }

  removeSpace(){
    if(this.textInput && !this.textInput.nativeElement.value.trim()){
      this.textInput.nativeElement.value = null;
    }
  }

  public clear() {
    this.signaturePad ? this.signaturePad.clear() : '';
    this.resetSign();
  }

  updateImage() {
    // if (!this.image.nativeElement.src) {
    //   this.initFontFamily();
    // }
    const tCtx = this.singnatureContext || this.textCanvas.nativeElement.getContext('2d');
    let value_input = this.signContent || this.textInput.nativeElement.value || '';
    value_input = this.toTitleCase(this.textInput.nativeElement.value);
    const inputValue = value_input.replace(/^./, value_input && value_input[0].toUpperCase());
    tCtx.clearRect(0, 0, tCtx.canvas.width, tCtx.canvas.height);
    const textWidth = 760;
    const textHeight = 80;
    tCtx.canvas.width = textWidth + 250;
    tCtx.canvas.height = textHeight + 200;
    tCtx.translate(tCtx.canvas.width / 2, tCtx.canvas.height / 2);
    const angle = -10 * Math.PI / 180;
    tCtx.rotate(angle);
    let baseFontSize = 40;
    if (inputValue && inputValue.length > 20) {
      baseFontSize = 30;
    }
    tCtx.font = `italic 500 30px Lato`;
    if(this.fromApplyFont == 1){
      tCtx.font = `italic ${baseFontSize}px BrotherSignature${this.count2}`;
    switch (tCtx.font) {
      case `italic ${baseFontSize}px BrotherSignature7`:
      case `italic ${baseFontSize}px BrotherSignature2`:
        tCtx.font = `italic ${baseFontSize + 5}px BrotherSignature${this.count2}`;
        break;
      case `italic 30px BrotherSignature8`:
        tCtx.font = `italic 25px BrotherSignature${this.count2}`;
        break;
      case `italic 40px BrotherSignature8`:
        tCtx.font = `italic 30px BrotherSignature${this.count2}`;
        break;
      case `italic 40px BrotherSignature1`:
      case `italic 40px BrotherSignature12`:
        tCtx.font = `italic 30px BrotherSignature${this.count2}`;
        break;
      case `italic 40px BrotherSignature13`:
        tCtx.font = `italic 500 30px Lato`;
        break;
      case `italic 30px BrotherSignature13`:
        tCtx.font = `italic 500 30px Lato`;
        break;
      }
    }
    tCtx.fillText(inputValue, -textWidth / 2, textHeight / 4);
    tCtx.setTransform(1, 0, 0, 1, 0, 0);
    // this.image.nativeElement.src = tCtx.canvas.toDataURL();
    this.image.nativeElement.src = this.trimCanvas(this.textCanvas.nativeElement, tCtx).toDataURL();
    const dataURI = this.image.nativeElement.src;
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {
      type: 'image/jpeg'
    });
    if (this.showImg) {
      this.signature = blob;
      this.signContent = this.textInput.nativeElement.value || '';
      clearInterval(this.intervalId2);
      this.count2++;
    }
    if(!this.signContent){
      this.resetSign();
    }
    // if (this.count2 == 1) {
    //   this.updateImage();
    // }
    if (this.count2 >= 15) {
      this.count2 = 0;
      // tslint:disable-next-line:align
    } if (this.count2 == 3 && this.counterboolean) {
      this.count2 = 0;
      this.counterboolean = false;
    }
    this.fromApplyFont = 0;
  }

  resetSign(){
    this.signature = '';
    const blob = undefined;
    this.signature = blob;
    this.singnatureContext = '';
    this.propagateChange(this.signature);
  }

  applyFont(){
    this.fromApplyFont = 1;
    this.updateImage();
  }

  toTitleCase(str) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }


  initFontFamily() {
    if (this.selectedTabs == 1) {
      this.intervalId = setInterval(() => {
        const tCtx: any = this.textCanvas.nativeElement.getContext('2d');
        tCtx.font = `italic 30px BrotherSignature${this.counter}`;
        this.counter++;
        if (this.counter === 16) {
          clearInterval(this.intervalId);
        }
      }, 1000);
    }
  }

  showSignImg() {
    if (!this.textInput.nativeElement.value) {
      clearInterval(this.intervalId2);
      return;
    }
    if (this.showSigns) {
      this.showImg = true;
      this.updateImage();
    }
  }

  get signature(): any {
    return this._signature;
  }

  set signature(value: any) {
    this._signature = value;
    if (value) {
      this.propagateChange(this.signature);
    }
  }

  public writeValue(value: any): void {
    this._signature = value || null;
    // tslint:disable-next-line:no-unused-expression
    // this.signaturePad && this.signaturePad.fromDataURL(this.signature);
  }

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(): void { }
  public drawBegin(): void { }

  public drawComplete(): void {
    // this.signature = this.signaturePad.toDataURL();
    const dataURI = this.signature;
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {
      type: 'image/jpeg'
    });
    this.signature = blob;
  }



  trimCanvas(canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D): HTMLCanvasElement {
    const width = canvas.width;
    const height = canvas.height;
    const imageData = ctx.getImageData(0, 0, width, height).data;
    let top = height, left = width, right = 0, bottom = 0;
    // Determine the bounding box of non-transparent pixels
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const index = (y * width + x) * 4;
        const alpha = imageData[index + 3]; // Alpha value

        if (alpha > 0) {
          if (x < left) left = x;
          if (x > right) right = x;
          if (y < top) top = y;
          if (y > bottom) bottom = y;
        }
      }
    }
    const trimmedWidth = right - left + 1;
    const trimmedHeight = bottom - top + 1;
    // Create a new canvas to draw the trimmed area
    const trimmedCanvas = document.createElement('canvas');
    const trimmedCtx = trimmedCanvas.getContext('2d');
    if (!trimmedCtx) return canvas;
    trimmedCanvas.width = trimmedWidth;
    trimmedCanvas.height = trimmedHeight;
    // Draw the trimmed area of the original canvas onto the new canvas
    trimmedCtx.drawImage(canvas, left, top, trimmedWidth, trimmedHeight, 0, 0, trimmedWidth, trimmedHeight);
    return trimmedCanvas;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.textInput) {
        this.textInput.nativeElement.addEventListener('keyup', () => this.updateImage());
          this.textInput.nativeElement.value = this.name;
          this.showSigns = true;
          this.showSignImg();
      }
    }, 100);
  }


  save(): void {
    const dataURL = this.signaturePad.toDataURL();
    const byteString = atob(dataURL.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {
      type: 'image/jpeg'
    });
    this.signature = blob;

    // this.signatureSaved.emit(dataURL)
    // You can send this dataURL to your backend for further processing/storage
  }
}
